"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceKeys = exports.AdapterName = exports.AdapterNames = exports.ResourceFormats = void 0;
exports.ResourceFormats = ['combined', 'separate'];
exports.AdapterNames = ['utah', 'hcpnv', 'mhp'];
exports.AdapterName = {
    MHP: 'mhp',
    UTAH: 'utah',
    HCPNV: 'hcpnv',
};
var ResourceKeys;
(function (ResourceKeys) {
    ResourceKeys["MEDICATION-DETAIL"] = "MEDICATION-DETAIL";
    ResourceKeys["MEDICATION-LIST"] = "MEDICATION-LIST";
})(ResourceKeys || (exports.ResourceKeys = ResourceKeys = {}));
//# sourceMappingURL=adapter-types.js.map